import { z } from 'zod';
import {
    buildStoredJsonValueParser,
    defineStoredJsonContract,
} from '../stored-json-contract.types';
import type {
    IdempotencyCleanupResponse,
    IdempotencyConflictCode,
    IdempotencyConflictResponse,
    IdempotencyResponseBodySnapshot,
} from '../idempotency.types';
import { JsonValueSchema, NonEmptyStringSchema } from './common.schemas';

export const IdempotencyConflictCodeSchema: z.ZodType<IdempotencyConflictCode> = z.union([
    z.literal('IDEMPOTENCY_REQUEST_IN_PROGRESS'),
    z.literal('IDEMPOTENCY_REQUEST_ALREADY_COMPLETED'),
    z.literal('IDEMPOTENCY_KEY_REUSED_WITH_DIFFERENT_REQUEST'),
]);

export const IdempotencyConflictResponseSchema: z.ZodType<IdempotencyConflictResponse> = z.object(
    {
        code: IdempotencyConflictCodeSchema,
        message: NonEmptyStringSchema,
        conflict_resource_type: z.literal('IDEMPOTENCY_REQUEST'),
        conflict_uuid: z.uuid(),
        conflict_field: NonEmptyStringSchema.optional(),
        conflict_value: NonEmptyStringSchema.optional(),
    }
);

export const IdempotencyCleanupResponseSchema: z.ZodType<IdempotencyCleanupResponse> = z.object({
    deleted_count: z.number().int().nonnegative(),
});

export const IdempotencyResponseBodySnapshotSchema: z.ZodType<
    IdempotencyResponseBodySnapshot
> = JsonValueSchema;

export function normalizeIdempotencyResponseBodySnapshotStorageV1(
    snapshot: IdempotencyResponseBodySnapshot
): IdempotencyResponseBodySnapshot {
    return snapshot;
}

export const IdempotencyResponseBodySnapshotStorageContract =
    defineStoredJsonContract({
        contractName: 'IdempotencyResponseBodySnapshot',
        semanticFieldValues: {},
        variants: {
            v1: {
                schemaName:
                    'IdempotencyResponseBodySnapshotSchema',
                schema: IdempotencyResponseBodySnapshotSchema,
                guards: [],
                normalize:
                    normalizeIdempotencyResponseBodySnapshotStorageV1,
                semanticPaths: {},
                unrepresentedSemanticFields: [],
            },
        },
        writerVariant: 'v1',
    });

export const StoredIdempotencyResponseBodySnapshotParser:
    z.ZodType<IdempotencyResponseBodySnapshot> =
    buildStoredJsonValueParser(
        IdempotencyResponseBodySnapshotStorageContract
    );
